function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconConversation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 22"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.063.448h13.874A2.07 2.07 0 0 1 19 2.51v8.904a2.07 2.07 0 0 1-2.063 2.063H9.414v3.675c0 .347-.377.434-.656.217l-5.013-3.892h-.682A2.07 2.07 0 0 1 1 11.415V2.511A2.07 2.07 0 0 1 3.063.448",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#b7c0c8"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.937 4.512H15.063A2.07 2.07 0 0 0 13 6.576v8.904a2.07 2.07 0 0 0 2.063 2.063h7.522v3.674c0 .347.378.434.657.217l5.013-3.891h.682A2.07 2.07 0 0 0 31 15.48V6.576a2.07 2.07 0 0 0-2.063-2.064",
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#09f"
  }
}));
export default SvgIconConversation;